/**
 * Enum consisting of all available S3 buckets
 */
export enum S3Buckets {
  Assets = 'assets.idearoom.com', // New assets bucket
  VendorAssets = 'vendorassets.shedview.com', // Old assets bucket
  Watermarks = 'watermark-service-production',
  IdeaRoomI18n = 'idearoom-i18n',
}
